import { render } from "./Maintenance.vue?vue&type=template&id=79a3dd8e&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"

import "./Maintenance.vue?vue&type=style&index=0&id=79a3dd8e&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a3dd8e"]])

export default __exports__